import React from 'react';
import { useTranslation } from 'react-i18next';
import { BodyText, Column } from '@chargify/custom-ui-components';

type Props = {
  existingBalance: string;
  billingEndDate: string;
  nextBillingAmount: string;
  productName: string;
  isImmediate: boolean;
};
export const NonProratedColumns = ({
  existingBalance,
  productName,
  billingEndDate,
  nextBillingAmount,
  isImmediate,
}: Props) => {
  const { t } = useTranslation(['subscriptions-manager']);
  return (
    <>
      {isImmediate ? (
        <>
          <Column span={16}>
            <BodyText variant={'body2'} color={'gray.dark'} fontWeight={600}>
              {t('plan_change.current_credit_service_balance')}
            </BodyText>
          </Column>
          <Column span={8}>
            <BodyText
              textAlign={'right'}
              color={'success.main'}
              fontWeight={700}
            >
              {existingBalance}
            </BodyText>
          </Column>
        </>
      ) : null}
      <Column span={16}>
        <BodyText variant={'body2'} color={'gray.dark'} fontWeight={600}>
          {t('plan_change.next_billing_amount', {
            planName: productName,
            date: billingEndDate,
          })}
        </BodyText>
      </Column>
      <Column span={8}>
        <BodyText textAlign={'right'} color={'success.main'} fontWeight={700}>
          {nextBillingAmount}
        </BodyText>
      </Column>
    </>
  );
};
